import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0889abfa&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0889abfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889abfa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutWavesBackgroundTop: require('/home/luiz/Sistemas/loja/components/Layout/WavesBackgroundTop.vue').default})
